export const countryEntranceFormatter = (values) => ({
  entranceType: values.entranceType,
});
